module.exports = __webpack_public_path__ + "img/Drenge.b79fedd2.jpg";